  export const diseases_image_thai = [

    // Page 12
    {
      label: 'Asthma',
      label_show: 'หอบหืด',
      page: 12,
      Xpos_image: '296px',
      Ypos_image: '480px',
      Xlabel: '313px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Food allergy',
      label_show: 'ภูมิแพ้อาหาร',
      page: 12,
      Xpos_image: '559px',
      Ypos_image: '480px',
      Xlabel: '561px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Eczema',
      label_show: 'ภูมิแพ้ผิวหนังอักเสบ',
      page: 12,
      Xpos_image: '428px',
      Ypos_image: '480px',
      Xlabel: '414px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Allergic rhinitis',
      label_show: 'ภูมิแพ้อากาศ',
      page: 12,
      Xpos_image: '165px',
      Ypos_image: '480px',
      Xlabel: '169px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Metabolic syndrome',
      label_show: 'ไขมันในเลือดผิดปกติ',
      page: 12,
      Xpos_image: '165px',
      Ypos_image: '605px',
      Xlabel: '149px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Overweight',
      label_show: 'น้ำหนักเกิน',
      page: 12,
      Xpos_image: '296px',
      Ypos_image: '605px',
      Xlabel: '305px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Type 2 diabetes',
      label_show: ['เบาหวาน','ประเภท 2'],
      page: 12,
      Xpos_image: '428px',
      Ypos_image: '605px',
      Xlabel: '438px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Excessive lipopolysaccharide',
      label_show: ['สาร Lipopolysaccharide สูง'],
      page: 12,
      Xpos_image: '559px',
      Ypos_image: '605px',
      Xlabel: '523px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Constipation',
      label_show: 'ท้องผูก',
      page: 12,
      Xpos_image: '230px',
      Ypos_image: '731px',
      Xlabel: '244px',
      Ylabel: '806px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Diarrhea',
      label_show: 'ท้องเสีย',
      page: 12,
      Xpos_image: '361px',
      Ypos_image: '731px',
      Xlabel: '374px',
      Ylabel: '806px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Immune disorder',
      label_show: 'ภูมิคุ้มกันบกพร่อง',
      page: 12,
      Xpos_image: '493px',
      Ypos_image: '731px',
      Xlabel: '481px',
      Ylabel: '806px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Insomnia/ poor sleep quality',
      label_show: 'การนอนผิดปกติ',
      page: 12,
      Xpos_image: '295px',
      Ypos_image: '858px',
      Xlabel: '288px',
      Ylabel: '933px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Stress and anxiety',
      label_show: 'ภาวะซึมเศร้าและเครียด',
      page: 12,
      Xpos_image: '426px',
      Ypos_image: '858px',
      Xlabel: '407px',
      Ylabel: '933px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Overweight',
      label_show: '',
      page: 24,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Allergic rhinitis',
      label_show: '',
      page: 15,
      Xpos_image: '52px',
      Ypos_image: '760px',
      Xlabel: '169px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Asthma',
      label_show: '',
      page: 15,
      Xpos_image: '52px',
      Ypos_image: '838px',
      Xlabel: '169px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Eczema',
      label_show: '',
      page: 15,
      Xpos_image: '52px',
      Ypos_image: '915px',
      Xlabel: '169px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Food allergy',
      label_show: '',
      page: 15,
      Xpos_image: '52px',
      Ypos_image: '992px',
      Xlabel: '169px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Eczema',
      label_show: '',
      page: 18,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Food allergy',
      label_show: '',
      page: 19,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    // Page 13
    // {
    //   label: 'Asthma',
    //   label_show: '',
    //   page: 13,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },

    // Page 14
    // {
    //   label: 'Food allergy',
    //   label_show: '',
    //   page: 14,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },

    // Page 16
    {
      label: 'Allergic rhinitis',
      label_show: '',
      page: 16,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    {
      label: 'Asthma',
      label_show: '',
      page: 17,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 18
    // {
    //   label: 'Overweight',
    //   label_show: 'น้ำหนักเกิน',
    //   page: 18,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '84px',
    //   Ylabel: '321px',
    //   width: '70px',
    //   height: 'auto'
    // },
    {
      label: 'Metabolic syndrome',
      label_show: '',
      page: 21,
      Xpos_image: '50px',
      Ypos_image: '81px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Type 2 diabetes',
      label_show: '',
      page: 26,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    // {
    //   label: 'Excessive lipopolysaccharide',
    //   label_show: ['มีสารพิษ ', 'lipopolysaccharide', '(LPS) สะสมในปริมาณ'],
    //   page: 18,
    //   Xpos_image: '77px',
    //   Ypos_image: '585px',
    //   Xlabel: '56px',
    //   Ylabel: '661px',
    //   width: '70px',
    //   height: 'auto'
    // },

    // Page 19
    // {
    //   label: 'Overweight',
    //   label_show: '',
    //   page: 19,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },

    // Page 20
    // {
    //   label: 'Metabolic syndrome',
    //   label_show: '',
    //   page: 20,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },

    // Page 21
    // {
    //   label: 'Type 2 diabetes',
    //   label_show: '',
    //   page: 21,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },

    {
      label: 'Excessive lipopolysaccharide',
      label_show: '',
      page: 23,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Excessive lipopolysaccharide',
      label_show: '',
      page: 21,
      Xpos_image: '50px',
      Ypos_image: '160px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Overweight',
      label_show: '',
      page: 21,
      Xpos_image: '50px',
      Ypos_image: '238px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Type 2 diabetes',
      label_show: '',
      page: 21,
      Xpos_image: '50px',
      Ypos_image: '315px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Constipation',
      label_show: '',
      page: 29,
      Xpos_image: '50px',
      Ypos_image: '81px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Diarrhea',
      label_show: '',
      page: 29,
      Xpos_image: '50px',
      Ypos_image: '159px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Immune disorder',
      label_show: '',
      page: 29,
      Xpos_image: '50px',
      Ypos_image: '236px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Constipation',
      label_show: '',
      page: 29,
      Xpos_image: '50px',
      Ypos_image: '390px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Diarrhea',
      label_show: '',
      page: 31,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Immune disorder',
      label_show: '',
      page: 33,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Stress and anxiety',
      label_show: '',
      page: 35,
      Xpos_image: '50px',
      Ypos_image: '794px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Insomnia/ poor sleep quality',
      label_show: '',
      page: 35,
      Xpos_image: '50px',
      Ypos_image: '872px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Stress and anxiety',
      label_show: '',
      page: 36,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Insomnia/ poor sleep quality',
      label_show: '',
      page: 37,
      Xpos_image: '50px',
      Ypos_image: '137px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
  ];


    export const diseases_thai = [
    // {
    //   label: 'Asthma',
    //   label_show: 'หอบหืด',
    //   page: 11,
    //   Xpos_image: '156px',
    //   Ypos_image: '535px',
    //   Xlabel: '175px',
    //   Ylabel: '620px',
    //   width: '79px',
    //   height: 'auto',
    //   result_comp: [
    //     { min: 1, max: 3, image: 'asthma_0' },
    //     { min: 4, max: 6, image: 'asthma_1' },
    //     { min: 7, max: 10, image: 'asthma_2' }
    //   ]
    // },
    // {
    //     label: 'Food allergy',
    //     label_show: 'ภูมิแพ้อาหาร',
    //     page: 11,
    //     Xpos_image: '292px',
    //     Ypos_image: '535px',
    //     Xlabel: '299px',
    //     Ylabel: '620px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'foodallergy_0' },
    //       { min: 4, max: 6, image: 'foodallergy_1' },
    //       { min: 7, max: 10, image: 'foodallergy_2' }
    //     ]
    //   },
    //   {
    //     label: 'Eczema',
    //     label_show: 'ภูมิแพ้ผิวหนัง',
    //     page: 11,
    //     Xpos_image: '426px',
    //     Ypos_image: '535px',
    //     Xlabel: '434px',
    //     Ylabel: '620px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'eczema_0' },
    //       { min: 4, max: 6, image: 'eczema_1' },
    //       { min: 7, max: 10, image: 'eczema_2' }
    //     ]
    //   },
    //   {
    //     label: 'Allergic rhinitis',
    //     label_show: 'ภูมิแพ้จมูกอักเสบ',
    //     page: 11,
    //     Xpos_image: '561px',
    //     Ypos_image: '535px',
    //     Xlabel: '560px',
    //     Ylabel: '620px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'allergicrhiniitis_0' },
    //       { min: 4, max: 6, image: 'allergicrhiniitis_1' },
    //       { min: 7, max: 10, image: 'allergicrhiniitis_2' }
    //     ]
    //   },
    //   {
    //     label: 'Overweight',
    //     label_show: 'น้ำหนักเกิน',
    //     page: 11,
    //     Xpos_image: '156px',
    //     Ypos_image: '670px',
    //     Xlabel: '168px',
    //     Ylabel: '757px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'overweight_0' },
    //       { min: 4, max: 6, image: 'overweight_1' },
    //       { min: 7, max: 10, image: 'overweight_2' }
    //     ]
    //   },
      {
        label: 'Metabolic syndrome',
        label_show: '',
        page: 22,
        Xpos_image: '50px',
        Ypos_image: '137px',
        Xlabel: '73px',
        Ylabel: '1065px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'metabolicsyndrome_0' },
          { min: 4, max: 6, image: 'metabolicsyndrome_1' },
          { min: 7, max: 10, image: 'metabolicsyndrome_2' }
        ]
      },
    //   {
    //     label: 'Type 2 diabetes',
    //     label_show: 'เบาหวานประเภท 2',
    //     page: 11,
    //     Xpos_image: '426px',
    //     Ypos_image: '670px',
    //     Xlabel: '422px',
    //     Ylabel: '757px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'type2diabetes_0' },
    //       { min: 4, max: 6, image: 'type2diabetes_1' },
    //       { min: 7, max: 10, image: 'type2diabetes_2' }
    //     ]
    //   },
    //   {
    //     label: 'Excessive lipopolysaccharide',
    //     label_show: ['มีสารพิษ lipopolysaccharide', '(LPS) สะสมในปริมาณมาก'],
    //     page: 11,
    //     Xpos_image: '561px',
    //     Ypos_image: '670px',
    //     Xlabel: '528px',
    //     Ylabel: '757px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'excessivelipopolysaccharide_0' },
    //       { min: 4, max: 6, image: 'excessivelipopolysaccharide_1' },
    //       { min: 7, max: 10, image: 'excessivelipopolysaccharide_2' }
    //     ]
    //   },
    //   {
    //     label: 'Constipation',
    //     label_show: 'ท้องผูก',
    //     page: 11,
    //     Xpos_image: '224px',
    //     Ypos_image: '815px',
    //     Xlabel: '243px',
    //     Ylabel: '900px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'constipation_0' },
    //       { min: 4, max: 6, image: 'constipation_1' },
    //       { min: 7, max: 10, image: 'constipation_2' }
    //     ]
    //   },
    //   {
    //     label: 'Diarrhea',
    //     label_show: 'ท้องเสีย',
    //     page: 11,
    //     Xpos_image: '360px',
    //     Ypos_image: '815px',
    //     Xlabel: '379px',
    //     Ylabel: '900px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'diarrhea_0' },
    //       { min: 4, max: 6, image: 'diarrhea_1' },
    //       { min: 7, max: 10, image: 'diarrhea_2' }
    //     ]
    //   },
    //   {
    //     label: 'Immune disorder',
    //     label_show: 'ภูมิคุ้มกันบกพร่อง',
    //     page: 11,
    //     Xpos_image: '495px',
    //     Ypos_image: '815px',
    //     Xlabel: '492px',
    //     Ylabel: '900px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'immunedisorder_0' },
    //       { min: 4, max: 6, image: 'immunedisorder_1' },
    //       { min: 7, max: 10, image: 'immunedisorder_2' }
    //     ]
    //   },
    //   {
    //     label: 'Insomnia/ poor sleep quality',
    //     label_show: 'นอนไม่หลับ',
    //     page: 11,
    //     Xpos_image: '295px',
    //     Ypos_image: '945px',
    //     Xlabel: '307px',
    //     Ylabel: '1030px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'insommnia_0' },
    //       { min: 4, max: 6, image: 'insommnia_1' },
    //       { min: 7, max: 10, image: 'insommnia_2' }
    //     ]
    //   },
    //   {
    //     label: 'Stress and anxiety',
    //     label_show: 'อาการเครียดและกระวนกระวาย',
    //     page: 11,
    //     Xpos_image: '430px',
    //     Ypos_image: '945px',
    //     Xlabel: '400px',
    //     Ylabel: '1030px',
    //     width: '79px',
    //     height: 'auto',
    //     result_comp: [
    //       { min: 1, max: 3, image: 'stress_0' },
    //       { min: 4, max: 6, image: 'stress_1' },
    //       { min: 7, max: 10, image: 'stress_2' }
    //     ]
    //   },
  ];